var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('info',{attrs:{"infos":[
      {label:'ID',value:_vm.vo.id},
      {label:'姓名',value:_vm.vo.name},
      {label:'身份证号',value:_vm.vo.idNumber},
      {label:'手机号',value:_vm.vo.phone},
      {label:'个性签名',value:_vm.vo.title},
      {label:'注册地址',value:_vm.utils.array.joinArrToStr([_vm.vo.addressProvince,_vm.vo.addressCity],'-')},
      {label:'个人介绍',value:_vm.vo.desc},
      {label:'审核状态',value:_vm.vo.examine},
      {label:'学历',value:_vm.vo.educationLevelText || '无'},
      {label:'毕业学校',value:_vm.vo.school || '无'},
      {label:'籍贯',value:_vm.vo.nativePlaceProvince ? (_vm.vo.nativePlaceProvince + ' '+_vm.vo.nativePlaceCity): '无'}
  ]}}),_c('div',{staticClass:"title"},[_vm._v("资质材料")]),_c('div',{staticClass:"imgs"},_vm._l((_vm.vo.imgs),function(img,index){return _c('div',{key:index,staticClass:"img-item"},[_c('cloud-img',{attrs:{"url":img.url,"img-width":100,"img-height":100,"border-radius":6,"click-view":true}}),_c('div',{staticClass:"info-text"},[_vm._v(_vm._s(img.certName))])],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }